import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './SimcardDetail.module.scss';
import SVG from 'react-inlinesvg';
import Button from '../../../shared/components/Button';
import Loading from '../../../app/components/Loading/Loading';
import Tooltip from '@material-ui/core/Tooltip';
import { useHistory, useLocation } from 'react-router-dom';
import { launchSVG } from '../../../../src/shared/helpers/icons';
import { toast } from '../../../shared/helpers/toast';
import ModalResetSimcard from './ModalResetSimcard';

const SimcardDetail = ({ simcards: { simCards, fetching, history:historySimcards, historyFetching, substatuses = [], substatusesFetching = false }, getSimCardsRequest, getHistorySimcardsRequest, getGpsDevicesRequest, gps, getSimcardsSubstatusesRequest, patchSimcardsBatchRequest, setSimcardSelected }) => {
    const [pendingIccid, setPendingIccid] = useState(null);
    const [resetModalOpen, setResetModalOpen] = useState(false);
    const { iccid } = useParams();
    const { t } = useTranslation(['home', 'devices']);
    const history = useHistory();
    const location = useLocation();

    const handleBack = () => {
        if (location.state && location.state.from) {
            history.push(location.state.from);
        } else {
            history.goBack();
        }
    };

    useEffect(() => {
        if (iccid) {
            getSimCardsRequest({ iccid: decodeURIComponent(iccid) });
        }
    }, [iccid, getSimCardsRequest]);

    useEffect(() => {
        if (iccid) {
            const decodedIccid = decodeURIComponent(iccid);
            getHistorySimcardsRequest(decodedIccid);
        }
    }, [iccid, getHistorySimcardsRequest]);

    useEffect(() => {
        if (
            pendingIccid &&
            gps &&
            Array.isArray(gps.gps_devices)
        ) {
            if (gps.gps_devices.length === 0) {
                toast('Intente nuevamente', 'gps-not-found');
                setPendingIccid(null);
                return;
            }
            const gpsFound = gps.gps_devices.find(
                g => g.simcard && g.simcard.iccid === pendingIccid
            );
            if (gpsFound && gpsFound.name) {
                history.push(`/stock/gps/${gpsFound.name}`);
                setPendingIccid(null);
            }
        }
    }, [gps, pendingIccid, history]);

    const simcard = simCards?.find(s => s.iccid === decodeURIComponent(iccid));

    if (!simcard || fetching) {
        return <Loading />;
    }
const changeFormatDate = (date) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <h3 className={styles.title}>{t('devices:simcard_detail')}</h3>
                </div>
                {simcard.status_name !== 'Asignado a GPS' && simcard.status_name !== 'Bodega' && (
                    <div className={styles.buttonsContainer}>
                        <Button className={styles.buttonReset} onClick={() => setResetModalOpen(true)}>
                            Resetear
                        </Button>
                    </div>
                )}
            </div>
            <ModalResetSimcard
                open={resetModalOpen}
                onClose={() => setResetModalOpen(false)}
                simcard={simcard}
                getSimcardsSubstatusesRequest={getSimcardsSubstatusesRequest}
                substatuses={substatuses}
                fetchingSubstatuses={substatusesFetching}
                patchSimcardsBatchRequest={patchSimcardsBatchRequest}
                getSimCardsRequest={getSimCardsRequest}
                setSimcardSelected={setSimcardSelected}
                iccid={iccid}
            />
            <div className={styles.section}>
                <div className={styles.tableContainer}>
                    <table className={styles.gpsTable}>
                        <thead className={styles.headerTable}>
                            <tr>
                            <th className={styles.colNumber}>{t('home:number')}</th>
                            <th className={styles.colOperator}>{t('devices:operator')}</th>
                            <th className={styles.colIccid}>ICCID</th>
                                <th className={styles.colStatus}>{t('home:status')}</th>
                                <th className={styles.colSubstatus}></th>
                                <th className={styles.colDate}>Creación</th>
                                <th className={styles.colEnabled}>{t('devices:enabled')}</th>
                                <th className={styles.colActions}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>{simcard.number}</td>
                            <td>{simcard.operator}</td>
                            <td>{simcard.iccid}</td>
                             
                              
                               
                               
                                <td className={styles.statusCell}>
                                    {simcard.status_name !== '-' ? (
                                        <div className={`${styles.status} ${styles[simcard.status_name?.toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                            {simcard.status_name || '-'}
                                        </div>
                                    ) : '-'}
                                    {simcard.status_name !== '-'  && <span className={styles.arrow}>›</span>}
                                </td>
                                <td>
                                    {(simcard.status_name?.toLowerCase() === 'baja' ||
                                        !simcard.substatus ||
                                        (typeof simcard.substatus === 'object'
                                        ? simcard.substatus.value?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado'
                                        : simcard.substatus?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado')
                                    ) ? (
                                        <div className={styles.status}>-</div>
                                    ) : (
                                        <div
                                        className={`${styles.status} ${
                                            styles[simcard.status_name?.toLowerCase().replace(/\s+/g, '-')] || ''
                                        }`}
                                        >
                                        {typeof simcard.substatus === 'object'
                                            ? simcard.substatus.value || simcard.substatus.name || '-'
                                            : simcard.substatus || '-'}
                                        </div>
                                    )}
                                    </td>

                                <td>{changeFormatDate(simcard.created)}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <SVG
                                        src={simcard.enabledIcon}
                                        className={`${styles.svg} ${simcard.enabled ? styles.enabled : styles.disabled}`}
                                    />
                                </td>
                                <td>
                                {["Asignado a GPS", "Asginado a GPS"].includes(simcard.status_name) ? (
        <Tooltip title="Ver GPS asignado" placement="bottom">
            <div 
                onClick={(e) => {
                    e.stopPropagation();
                    setPendingIccid(simcard.iccid);
                    if (typeof getGpsDevicesRequest === 'function') {

                        getGpsDevicesRequest({
                            search: simcard.iccid,
                            full_simcards: 1,
                            full_status: 1,
                            full_devices: 1,
                            full_assigned: 1,
                            full_company: 1,
                            limit: 50,
                            page: 1
                        });
                        
                    } else {
                        
                        toast('No se puede buscar el GPS asociado', 'gps-function-error');
                        setPendingIccid(null);
                    }
                }}
                className={styles.launchIconWrapper}
            >
                <SVG
                    src={launchSVG}
                    className={styles.launchIconn}
                />
            </div>
        </Tooltip>
    ) : (
        <div></div>
    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className={styles.section}>
                <h3 className={styles.subtitle}>Historial de movimientos</h3>
                <div className={`${styles.tableContainer} ${styles.withScroll}`}>
                    <table className={styles.gpsTable}>
                        <thead>
                            <tr>
                                <th className={styles.colFecha}>Fecha</th>
                                <th className={styles.colResponsable}>Responsable</th>
                                <th className={styles.colAccion}>Acción</th>
                                <th className={styles.colEstado}>De</th>
                                <th className={styles.colSubEstado}>A</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historyFetching ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Cargando historial...</td>
                                </tr>
                            ) : (!historySimcards || historySimcards.length === 0) ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No se han realizado movimientos</td>
                                </tr>
                            ) : (
                                historySimcards.map((movement, index) => (
                                                        <tr key={index}>
                                                            <td>{new Date(movement.date).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</td>
                                                            <td>{movement.responsible}</td>
                                                            <td>{movement.action}</td>
                                                            <td style={{ position: 'relative', paddingRight: '50px' }}>
                        {movement.previousData && typeof movement.previousData === 'string' &&
                        movement.previousData.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado' ? (
                            <div>-</div>
                        ) : movement.previousData ? (
                            <div className={`${styles.status} ${styles[movement.previousData.toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                {movement.previousData}
                            </div>
                        ) : (
                            <div>-</div>
                        )}
                        <span
                            className={styles.arrow}
                            style={{
                                position: 'absolute',
                                right: '25px',
                                visibility:
                                    movement.previousData &&
                                    typeof movement.previousData === 'string' &&
                                    movement.previousData.toLowerCase() !== 'baja'
                                        ? 'visible'
                                        : 'hidden'
                            }}
                        >
                            ›
                        </span>
                    </td>
                    <td>
                        {movement.newData && typeof movement.newData === 'string' &&
                        movement.newData.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === 'no asignado' ? (
                            <div>-</div>
                        ) : movement.newData ? (
                            <div className={`${styles.status} ${styles[movement.newData.toLowerCase().replace(/\s+/g, '-')] || ''}`}>
                                {movement.newData}
                            </div>
                        ) : (
                            <div>-</div>
                        )}
                    </td>

                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SimcardDetail;